import React from 'react';
import TabLinkButton from '../TabLinkButton/TabLinkButton';
import { resourceDarkGray } from '../../../styles/style-constants';

export type RouteTabMenuItem = {
  label: string;
  link: string;
  paramPath: string;
  component: any;
  icon?: any;
  exactRoute?: boolean;
  hasBadge?: boolean;
  favoritesBadge: any;
};

type Props = {
  items: Array<RouteTabMenuItem>;
  activeRoute: string;
  overflowUnderline?: boolean;
  isClickAwayOnly: boolean;
  counter: number;
} & any;

function RouteTabMenu(props: Props) {
  function renderButtons(): Array<React.ReactElement> {
    return props.items.map((tabMenuItem: RouteTabMenuItem, index: number) => {
      return (
        <TabLinkButton
          key={index}
          top={3}
          sideMargin={20}
          icon={tabMenuItem.icon}
          active={tabMenuItem.link === props.activeRoute}
          link={tabMenuItem.link}
          label={tabMenuItem.label}
          favoritesBadge={tabMenuItem.hasBadge}
          pinnedItems={props.counter}
        />
      );
    });
  }

  return (
    <div
      style={{
        position: 'relative',
        zIndex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: `1px solid ${resourceDarkGray}`,
        borderBottom: `1px solid ${resourceDarkGray}`
      }}
    >
      {renderButtons()}
    </div>
  );
}

export default RouteTabMenu;
